import type { FormEventHandler, ReactNode } from "react";

export type SwotFormShellProps = {
  readonly title?: string | undefined;
  readonly description?: string | undefined;
  readonly children: ReactNode;
  readonly actions?: ReactNode | undefined;
  readonly errorSummary?: ReactNode | undefined;
  readonly className?: string | undefined;
  readonly onSubmit?: FormEventHandler<HTMLFormElement> | undefined;
  readonly action?: ((formData: FormData) => void | Promise<void>) | undefined;
  readonly noValidate?: boolean | undefined;
  readonly dirty?: boolean | undefined;
  readonly disabled?: boolean | undefined;
};

export function SwotFormShell(props: SwotFormShellProps) {
  const describedBy = props.description ? "swot-form-shell-description" : undefined;
  const className = ["swot-form-shell", props.className, props.disabled ? "swot-form-shell--disabled" : undefined, props.dirty ? "swot-form-shell--dirty" : undefined]
    .filter(Boolean)
    .join(" ");

  return (
    <form className={className} onSubmit={props.onSubmit} action={props.action} noValidate={props.noValidate ?? true} aria-describedby={describedBy} aria-busy={props.disabled ? "true" : undefined}>
      {props.title ? <header className="swot-form-shell__header"><h2>{props.title}</h2>{props.description ? <p id="swot-form-shell-description">{props.description}</p> : null}</header> : null}
      {props.errorSummary ? <div className="swot-form-shell__error-summary">{props.errorSummary}</div> : null}
      <fieldset className="swot-form-shell__body" disabled={props.disabled}>
        {props.children}
      </fieldset>
      {props.actions ? <footer className="swot-form-shell__actions">{props.actions}</footer> : null}
    </form>
  );
}
